import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";
import {
    DashboardReportApiType,
    DashboardReportConfigResponse,
    DashboardReportListResponse,
    DashboardReportSavePayload,
    DashboardReportSaveResponse,
    DashboardReportType,
} from "@callveriq/type/DashboardReportConfig";

export const dashboardReportConfigApiSlice = createApi({
    reducerPath: "dashboardReportConfigApiSlice",
    baseQuery: axiosBaseQuery(),
    tagTypes: ["DashboardReportConfig", "DashboardReportList"],
    endpoints: (builder) => ({
        getDashboardReportsList: builder.query<
            DashboardReportListResponse,
            void
        >({
            query: () => ({
                url: "/analytics/email_report/",
                method: "GET",
            }),
            providesTags: ["DashboardReportList"],
        }),
        getDashboardReportConfig: builder.query<
            DashboardReportConfigResponse,
            DashboardReportApiType
        >({
            query: (reportType) => ({
                url: `/analytics/email_report/${reportType}/`,
                method: "GET",
            }),
            providesTags: (_result, _error, reportType) => [
                { type: "DashboardReportConfig", id: reportType },
            ],
        }),
        saveDashboardReportConfig: builder.mutation<
            DashboardReportSaveResponse,
            {
                reportType: DashboardReportApiType;
                body: DashboardReportSavePayload;
            }
        >({
            query: ({ reportType, body }) => ({
                url: `/analytics/email_report/${reportType}/`,
                method: "POST",
                body,
            }),
            invalidatesTags: (_result, _error, { reportType }) => [
                { type: "DashboardReportConfig", id: reportType },
            ],
        }),
    }),
});

export const {
    useGetDashboardReportsListQuery,
    useGetDashboardReportConfigQuery,
    useSaveDashboardReportConfigMutation,
} = dashboardReportConfigApiSlice;
